import React, { FC, ReactNode, CSSProperties } from "react";
import { Markup, MarkupProps } from "interweave";

const StyledMarkup: FC<
  Omit<MarkupProps, "content"> & {
    content?: ReactNode | null;
    style?: CSSProperties;
  }
> = ({ content, style, noWrap, ...props }) => {
  if (React.isValidElement(content)) return content;
  if (typeof content !== "string") return null;

  if (props.tagName) return <Markup content={content} {...props} />;
  if (noWrap) return <Markup content={content} {...props} noWrap />;
  return (
    <span style={style}>
      <Markup content={content} {...props} noWrap />
    </span>
  );
};

export default StyledMarkup;
